import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CustomQuestion, JoiEvent, Ranking } from 'globals/store/events.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import {  sleepForMS, titleCase } from '../../helpers/helpers';
import { readOnlyReselector } from '../../store/reselectors/permissions.reselector';
import { CustomAnswerColumnData, customAnswerColumns } from '../../helpers/table-column-types';
import { TableColumn } from '../../helpers/table.data';
import { saveTable } from '../../modules/performers/performerSharedFunctions';
import { SurveyResponsesTableComponent } from './survey-responses-table.component';
import { DropdownOption } from 'globals/store/programs.data';
import { surveyDropdownReselector } from '../../store/reselectors/apps.reselector';
import { DropdownComponent } from 'src/app/components/misc/dropdown.component';
import { ActionButtonComponent } from 'src/app/components/nav-bar/action-button.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'survey-responses',
    template: `
<ng-container *ngIf="{ noResponses: !loadingResponses && noResponses && surveyId, loading: surveyId && loadingResponses, showTable: !loadingResponses && !noResponses && surveyId } as vars">
  <div class="menu">
    <dropdown [selections]="surveyDropdownOptions" [null_text]="'Select an evaluation form'" [emptyText]="'Untitled Evaluation Form'" (select)="loadSurveyResponses($event)"></dropdown>
    <div style="flex:1;"></div>
    <action-button *ngIf="vars.showTable" id="export-table" [text]="'Export'" (click)="exportTable()"></action-button>
  </div>
  <survey-responses-table *ngIf="vars.showTable" [appId]="appId" [surveyId]="surveyId"></survey-responses-table>
  <div class="no-responses" *ngIf="vars.noResponses">
    There are no responses to this evaluation form
  </div>
  <div class="loading" *ngIf="vars.loading">Loading...</div>
</ng-container>

`,
    styles: [`
    :host { padding: 20px; width: 100%; display: block; }
    survey-responses-table { margin-top: 20px; display: flex; }
    .menu { display: flex; }
    .no-responses, .loading { margin: 20px auto; }
  `],
    standalone: true,
    imports: [DropdownComponent, ActionButtonComponent, SurveyResponsesTableComponent, CommonModule],
})
export class SurveyResponsesComponent extends Wrapper<SurveyResponsesComponent> implements OnInit {
  event: JoiEvent
  @Input() appId: string
  surveyId: string

  readOnly: boolean = true
  items: CustomAnswerColumnData[] = []
  customAnswerColumns = customAnswerColumns
  columns: TableColumn[] = []
  columnsById: Dictionary<TableColumn> = {}
  @ViewChild(SurveyResponsesTableComponent) surveyResponsesTable: SurveyResponsesTableComponent
  surveyDropdownOptions: DropdownOption[]
  loadingResponses: boolean = false
  noResponses: boolean


  exportTable() {
    this.surveyResponsesTable.exportTable()
  }

  async loadSurveyResponses(surveyDropdown: DropdownOption) {
    console.log("Should be loading ", surveyDropdown)
    this.loadingResponses = true
    this.surveyId = surveyDropdown.id
    try {
      const surveyResponses = await this.appService.downloadSubmissions({ appId: this.appId, surveyId: this.surveyId, eventId: this.event.eventId })
      console.log({ surveyResponses })
      this.noResponses = !surveyResponses?.length
    } catch (error) {
      console.log(error)
      this.noResponses = true
    } finally {
      await sleepForMS(100)
      this.loadingResponses = false
    }
    
  }

  ngOnInit() {
    this.selectProp(surveyDropdownReselector, this.appId, 'surveyDropdownOptions')
    this.subProp(this.store.select('events','event'), 'event')
    this.uiService.changePageTitle(`Evaluation Form Responses`, true)
  }


}